// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, addDoc,
  query,
  where,
  getDocs,
  doc,
  deleteDoc,
  updateDoc,
  serverTimestamp,
  arrayUnion } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA9POaFPDmFWLg2WiBtlZXU7sWlgbSG2E4",
  authDomain: "diamond-project-cf37b.firebaseapp.com",
  projectId: "diamond-project-cf37b",
  storageBucket: "diamond-project-cf37b.appspot.com",
  messagingSenderId: "381060633989",
  appId: "1:381060633989:web:98af578db08a986dc8a0ec",
  measurementId: "G-4VJB3Z508T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);


export{app,auth,createUserWithEmailAndPassword,collection, addDoc,db,storage,query,
  where,
  getDocs,doc,
  deleteDoc,ref,uploadBytes,getDownloadURL,updateDoc,serverTimestamp,arrayUnion}